export const starColors = ["#FF7373", "#FF7373", "#FF7373"]
export const satisfyColors = ["#99A9BF", "#F7BA2A", "#FF9900"]
export const satisfyIcons = [
  "custom-icon-rate-face-1",
  "custom-icon-rate-face-2",
  "custom-icon-rate-face-3"
]
